import { useState, useEffect } from 'react';

/**
 * Custom hook to detect scroll direction and if page is scrolled
 * @returns {{ scrollDirection: 'up' | 'down', isScrolled: boolean }}
 */
export function useScrollDirection() {
    const [scrollDirection, setScrollDirection] = useState('up');
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        let lastScrollY = window.scrollY;
        let ticking = false;

        const updateScrollDirection = () => {
            const scrollY = window.scrollY;

            // Determine if scrolled past threshold
            setIsScrolled(scrollY > 50);

            // Determine scroll direction with a small threshold
            if (Math.abs(scrollY - lastScrollY) < 5) {
                ticking = false;
                return;
            }

            setScrollDirection(scrollY > lastScrollY ? 'down' : 'up');
            lastScrollY = scrollY > 0 ? scrollY : 0;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDirection);
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return { scrollDirection, isScrolled };
}

export default useScrollDirection;
